import React from 'react';
import { StructuredDirective } from '../utils/structured-markdown';
import { EarningsReportComponentV2 } from './earnings-report-component-v2';
import { TranscriptComponent } from './transcript-component';

interface DirectiveRendererProps {
    directive: StructuredDirective;
    supportedTickers?: string[];
}

export const DirectiveRenderer: React.FC<DirectiveRendererProps> = ({ directive, supportedTickers = [] }) => {
    switch (directive.type) {
        case 'earnings':
            return (
                <div className="my-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <div className="text-sm text-gray-600 mb-2">
                        📊 Earnings Data - {directive.params.ticker} {directive.params.fiscalPeriod} {directive.params.fiscalYear}
                    </div>
                    <div className="bg-white rounded border p-2 max-h-96 overflow-y-auto">
                        {/* This would integrate with the actual earnings data loading logic */}
                        <div className="text-center text-gray-500 p-4">
                            Earnings report for {directive.params.ticker} would load here
                            <br />
                            <small>Fiscal Period: {directive.params.fiscalPeriod}, Year: {directive.params.fiscalYear}</small>
                            {directive.params.view && <><br /><small>View: {directive.params.view}</small></>}
                        </div>
                    </div>
                </div>
            );
        
        case 'transcript':
            return (
                <div className="my-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <div className="text-sm text-gray-600 mb-2">
                        🎙️ Transcript - {directive.params.ticker} {directive.params.fiscalDateEnding}
                    </div>
                    <div className="bg-white rounded border p-2 max-h-96 overflow-y-auto">
                        {/* This would integrate with the actual transcript data loading logic */}
                        <div className="text-center text-gray-500 p-4">
                            Transcript for {directive.params.ticker} would load here
                            <br />
                            <small>Fiscal Date Ending: {directive.params.fiscalDateEnding}</small>
                        </div>
                    </div>
                </div>
            );
        
        default:
            return (
                <div className="my-4 p-4 border border-orange-200 rounded-lg bg-orange-50">
                    <div className="text-sm text-orange-600">
                        Unknown directive type: {directive.type}
                    </div>
                </div>
            );
    }
};